<ion-list>
  <ion-item-divider>
    <ion-label>
      Order By:
    </ion-label>
  </ion-item-divider>
  <ion-item button detail (click)="order('date-desc')">
    <ion-label>
      Date: New to Old
    </ion-label>
  </ion-item>
  <ion-item button detail (click)="order('date-asc')">
    <ion-label>
      Date: Old to New
    </ion-label>
  </ion-item>
  <ion-item button detail (click)="order('price-desc')">
    <ion-label>
      Price: High to Low
    </ion-label>
  </ion-item>
  <ion-item button detail (click)="order('price-asc')">
    <ion-label>
      Price: Low to High
    </ion-label>
  </ion-item>
</ion-list>